import React, { useEffect, useState } from "react";
import { gql } from "@apollo/client";
import { styled } from "@material-ui/styles";
import { Paper } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import PlayerDashboard from "./PlayerDashboard";
import CoachDashboard from "./CoachDashboard";
import useIsManager from "../../hooks/useIsManager";
import CreateAndLinkPlayer from "../pages/create-and-link-player";
import { IStyledArguments } from "../../types/styled-arguments";

const CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      id
      name
      surname
      email
      role
      playerLink
      avatarUrl
      workspace
      playerProfile {
        id
        name
        surname
        number
        position
        dateOfBirth
        team
        totalGoals
        totalMatches
        isInvited
        yellowCards
        redCards
        scouting
        avatarUrl
      }
      notifications {
        id
        message
        timestamp
        read
      }
    }
  }
`;

const StyledPaper = styled(Paper)(({ theme }: IStyledArguments) => ({
  boxSizing: "border-box",
  marginBottom: theme.spacing(5),
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  maxWidth: 830,
  borderRadius: 16,
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.extra.borderColor}`,
  boxShadow: "0 1px 3px rgba(16, 21, 26, 0.06)",
  [theme.breakpoints.down("md")]: {
    marginBottom: theme.spacing(3),
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: 14,
    marginBottom: theme.spacing(2),
  },
}));

const PageDashboard = () => {
  const { data } = useQuery(CURRENT_USER);
  const [user, setUser] = useState<any>();

  useEffect(() => {
    if (data) {
      setUser(data.currentUser);
    }
  }, [data]);

  return (
    <StyledPaper>
      {/* <Loader
        {...queryResult}
        errorMessage={intl.formatMessage(messages.loadError)}
      > */}
      {user && useIsManager(user.role) && <CoachDashboard user={user} />}
      {/* {user &&
        !useIsManager(user.role) &&
        (user.playerLink || user.playerProfile) && (
          <PlayerDashboard id={user.playerLink} user={user} />
        )} */}
      {user && !useIsManager(user.role) && (
        <>
          {!user.playerLink ? (
            // <Redirect to={`/users/${user.id}/linkplayer`} noThrow />
            <CreateAndLinkPlayer
              callback={(playerId: string) => {
                const tmpUser = { ...user };
                tmpUser.playerLink = playerId;
                setUser(tmpUser);
              }}
            />
          ) : (
            <PlayerDashboard id={user.playerLink} user={user} />
          )}
        </>
      )}

      {/* </Loader>  */}
    </StyledPaper>
  );
};

export default PageDashboard;
